/**
 * react-query
 *
 * Copyright (c) TanStack
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
'use strict';

var _defineProperty = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _slicedToArray = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

Object.defineProperty(exports, '__esModule', {
  value: true
});

var React = require('react');

var shim = require('use-sync-external-store/shim');

var index = require('../../query-core/build/esm/index.js');

var QueryClientProvider = require('./QueryClientProvider.js');

var utils = require('./utils.js');

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);

  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function get() {
            return e[k];
          }
        });
      }
    });
  }

  n["default"] = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

function useMutation(arg1, arg2, arg3) {
  var options = index.parseMutationArgs(arg1, arg2, arg3);
  var queryClient = QueryClientProvider.useQueryClient({
    context: options.context
  });

  var _React__namespace$use = React__namespace.useState(function () {
    return new index.MutationObserver(queryClient, options);
  }),
      _React__namespace$use2 = _slicedToArray(_React__namespace$use, 1),
      observer = _React__namespace$use2[0];

  React__namespace.useEffect(function () {
    observer.setOptions(options);
  }, [observer, options]);
  var result = shim.useSyncExternalStore(React__namespace.useCallback(function (onStoreChange) {
    return observer.subscribe(index.notifyManager.batchCalls(onStoreChange));
  }, [observer]), function () {
    return observer.getCurrentResult();
  }, function () {
    return observer.getCurrentResult();
  });
  var mutate = React__namespace.useCallback(function (variables, mutateOptions) {
    observer.mutate(variables, mutateOptions).catch(noop);
  }, [observer]);

  if (result.error && utils.shouldThrowError(observer.options.useErrorBoundary, [result.error])) {
    throw result.error;
  }

  return _objectSpread(_objectSpread({}, result), {}, {
    mutate: mutate,
    mutateAsync: result.mutate
  });
} // eslint-disable-next-line @typescript-eslint/no-empty-function


function noop() {}

exports.useMutation = useMutation;